import Entity from '../entity';
import AirlineCompany from './airlineCompany';
import FromAirport from './fromAirport';
import PriceGenerals from './priceGenerals';
import ToAirport from './toAirport';

export default class Flight extends Entity<string> {
  fromAirportId: string;
  fromAirport: FromAirport;
  fromAirportName: string;
  toAirportId: string;
  toAirport: ToAirport;
  toAirportName: string;
  departureDate: string;
  arrivalDate: string;
  departureTerminalId: any;
  departureTerminal: any;
  arrivalTerminalId: any;
  arrivalTerminal: any;
  flightDuration: string;
  totalDuration: any;
  code: any;
  iataCode: string;
  departureHour: string;
  arrivalHour: string;
  flightHours: string;
  airlineName: string;
  flightNo: string;
  airCraftId: string;
  airCraft: any;
  airCraftFullName: any;
  airLineCompanyId: string;
  airlineCompany: AirlineCompany;
  airlineLogoUrl: any;
  packageProviderId: string;
  packageProvider: any;
  hasStops: boolean;
  stopCount: number;
  flightIsActive: boolean;
  dynamicId: boolean;
  minPrice: number;
  totalPrice: number;
  currencyId: string;
  currency: any;
  baggageLimit: number;
  numberOfSeats: number;
  changeCount: number;
  passengerCount: number;
  totalQuota: number;
  totalConfirmed: number;
  route: string;
  flightPrices: any[];
  flightPriceRules: any[];
  flightUrl: string;
  priceGenerals: PriceGenerals[];
}
